module.exports = __webpack_public_path__ + "img/medicines.2a7cc0a8.svg";